var map = {
	"./admissions/index.js": "8abe",
	"./appointments/index.js": "1488",
	"./auth/index.js": "e4ee",
	"./billing/index.js": "0c9f",
	"./checkout/index.js": "3747",
	"./clients/index.js": "bf77",
	"./corporate/index.js": "f428",
	"./dependents/index.js": "70df",
	"./diagnostic/index.js": "3d11",
	"./encounters/index.js": "2016",
	"./global/index.js": "7586",
	"./inventory/index.js": "4177",
	"./locations/index.js": "c98a",
	"./patientAllergies/index.js": "80b5",
	"./patients/index.js": "78d7",
	"./practitioners/index.js": "ba7d",
	"./resources/index.js": "33e3",
	"./roles/index.js": "86c0",
	"./schedules/index.js": "9ff4",
	"./services/index.js": "b4ed",
	"./visits/index.js": "d942",
	"./workspaces/index.js": "763c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2cd0";